import { IClient } from "./../pages/auth/login/index";
import { BehaviorSubject } from "rxjs";

import storage from "@services/storage.service";
import { userFromToken, isTokenExpired } from "@utils/helpers";
import authService from "./auth.service";
import Axios from "axios-observable";
import { createOktaSessionCheck } from "@utils/okta"
import { appInsights } from "../appInsights";
import { IdleTimerContext } from "react-idle-timer";
class Session {
  private _user: any = null;
  private _token: string = "";
  private _refreshToken: string = "";
  private _client: IClient | undefined;
  private _subject: BehaviorSubject<any> = new BehaviorSubject(false);
  private sessionCheckInterceptor: any;
  static reactIdealTimerContext = IdleTimerContext;

  constructor() {
    this.check();
  }

  private check() {
    const _token: string = storage.get("_token");

    if (!_token) {
      this.logout()
      this._subject.next(false);
      return false;
    }

    this._token = _token;
    this._user = storage.get("_user");

    if (!this._user) {
      this._user = userFromToken(this._token);
      storage.set("_user", this._user);
    }

    this._subject.next(true);
    return true;
  }

  get token() {
    if (!this._token) {
      this.check();
    }

    return this._token;
  }

  get user() {
    if (!this._token) {
      this.check();
    }

    return this._user;
  }

  set token(token: string) {
    storage.set("_token", token);
    this._token = token;
    this._user = userFromToken(token);
    storage.set("_user", this._user);
  }

  set user(user) {
    storage.set("_user", this.user);
    this._user = user;
  }

  isValidToken() {
    if (!this._token) {
      this._token = storage.get("_token");
    }
    return this._token && !isTokenExpired(this._token);
  }
  async getToken(): Promise<string> {
    this.check()
    if (this.isValidToken()) {
      return this._token;
    } else {
      //this.logout();
      //Call Refresh Token
      appInsights.trackEvent({ name: `Access Token Expired.`, properties: {email: this.getUser()?.email} });
      await this.refreshToken();
      return this._token;
    }
  }

  afterLogin() {
    this._token = storage.get("_token");
    this._refreshToken = storage.get("_refreshToken");
    this._user = storage.get("_user");
    this._client = storage.get("_client");
    this._subject.next(true);
    if (this._client?.provider === 'okta') {
      const sessionCheck = createOktaSessionCheck(this._client)
      this.sessionCheckInterceptor = Axios.interceptors.request.use(
        (config) => {
          sessionCheck()

          return config
        }
      )
    }
  }

  destroy() {
    storage.destroy();
    this._token = "";
    this._user = null;
    this._subject.next(false);
    this._refreshToken = "";
    this._client = undefined;
  }

  logout() {
    this.destroy();
    if (this.sessionCheckInterceptor) {
      Axios.interceptors.request.eject(this.sessionCheckInterceptor)
    }
  }

  subscribe(callback: Function) {
    return this._subject.subscribe((value: boolean) => {
      callback(value);
    });
  }
  async refreshToken() {
    if(storage.get("_refreshToken")) {
      return authService.refreshToken(storage.get("_refreshToken")).then(
        (res) => {
          const token = res?.data?.data?.accessToken;
          const refreshToken = res?.data?.data?.refreshToken;
          storage.set("_token", token);
          storage.set("_refreshToken", refreshToken);
          this._token = token;
          this._refreshToken = refreshToken;
          this._user = res?.data?.data?.user;
          storage.set("_user", this._user);
          this._subject.next(true);
        },
        (error) => {
          if(this.getUser()?.email) {
            appInsights.setAuthenticatedUserContext(this.getUser()?.email);
          }
          appInsights.trackEvent({ name: `Refresh Token Expired.`, properties: {error: error} });
          appInsights.clearAuthenticatedUserContext();
          this.logout();
          window.location.href = `/`;
        }
      );
    } else {
      appInsights.trackEvent({ name: `Refresh Token Not Available.`, properties: {currentLocation: window.location}});
      appInsights.clearAuthenticatedUserContext();
      this.logout();
      window.location.href = `/`;
    }
  }

  getClient(): IClient | undefined {
    if (this._client) {
      return this._client;
    } else {
      const _client: IClient = storage.get("_client");
      this._client = _client;
      return _client;
    }
  }

  getUser() {
    return this._user; 
  }
}

const sess = new Session();
export default sess;
